'use client'
import React, { useCallback, useEffect, useState } from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

const TOAST_EXIT_MS = 300;

const Toast = ({ message, type = 'info', onClose, duration = 10000 }) => {
    const [exiting, setExiting] = useState(false);

    const beginClose = useCallback(() => {
        setExiting((prev) => (prev ? prev : true));
    }, []);

    useEffect(() => {
        if (!exiting) return;
        const timer = setTimeout(() => {
            onClose();
        }, TOAST_EXIT_MS);
        return () => clearTimeout(timer);
    }, [exiting, onClose]);

    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                beginClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [duration, beginClose]);

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <CheckCircle className="w-5 h-5 text-green-400" />;
            case 'error':
                return <XCircle className="w-5 h-5 text-red-400" />;
            case 'warning':
                return <AlertCircle className="w-5 h-5 text-yellow-400" />;
            default:
                return <AlertCircle className="w-5 h-5 text-blue-400" />;
        }
    };

    const getBgColor = () => {
        switch (type) {
            case 'success':
                return 'bg-green-500/10 border-green-500/20 text-green-400';
            case 'error':
                return 'bg-red-500/10 border-red-500/20 text-red-400';
            case 'warning':
                return 'bg-yellow-500/10 border-yellow-500/20 text-yellow-400';
            default:
                return 'bg-blue-500/10 border-blue-500/20 text-blue-400';
        }
    };

    return (
        <div
            className={`pointer-events-auto w-[min(24rem,calc(100vw-5rem))] max-w-sm p-4 rounded-lg border shadow-2xl backdrop-blur-xl ${getBgColor()} toast-notification${exiting ? ' toast-notification--exit' : ''}`}
        >
            <div className="flex items-start space-x-3">
                {getIcon()}
                <div className="flex-1">
                    <p className="text-sm font-medium">{message}</p>
                </div>
                <button
                    onClick={beginClose}
                    className="flex-shrink-0 text-gray-400 hover:text-gray-200 transition-colors"
                    aria-label="Dismiss notification"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default Toast;
